import moment from 'moment';
import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { downloadFile } from 'actions/common';

export const GET_CIC_ALERT_REPORT_REQUEST = 'GET_CIC_ALERT_REPORT_REQUEST';
export const GET_CIC_ALERT_REPORT_SUCCESS = 'GET_CIC_ALERT_REPORT_SUCCESS';
export const GET_CIC_ALERT_REPORT_FAILURE = 'GET_CIC_ALERT_REPORT_FAILURE';

function requestGetCicAlertReport() {
  return {
    type: GET_CIC_ALERT_REPORT_REQUEST,
    isGettingCicAlertXls: true
  };
}

function receiveGetCicAlertReport() {
  return {
    type: GET_CIC_ALERT_REPORT_SUCCESS,
    isGettingCicAlertXls: false,
    cicAlertReportError: null
  };
}

function rejectGetCicAlertReport(cicAlertReportError) {
  return {
    type: GET_CIC_ALERT_REPORT_FAILURE,
    isGettingCicAlertXls: false,
    cicAlertReportError
  };
}

export function getCicAlertReportFile(requestObject) {
  return (dispatch) => {
    dispatch(requestGetCicAlertReport());

    const promise = () => ApiService
      .getCicAlertReport(
        requestObject.resolved,
        requestObject.pageNumber,
        requestObject.pageSize,
        requestObject.totalLimit,
        requestObject.sortByField,
        requestObject.sortDirection,
        requestObject.filterList,
        requestObject.raisedWithin,
        requestObject.legalEntity,
        requestObject.legalEntitySelected,
        requestObject.accountNumber,
        requestObject.accountNumberSelected,
        requestObject.customer,
        requestObject.customerSelected,
        { responseType: 'arraybuffer' }
      )
      .then((response) => {
        dispatch(receiveGetCicAlertReport());

        let fileName = `ALLCICALERTS-${ moment().format('YYYYMMDD-HHmm') }.xlsx`;
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=(?:UTF-8''|)?"?([^";]+)"?/i);
          const [, rawFileName] = match || [];
          if (rawFileName) {
            try {
              fileName = decodeURIComponent(rawFileName);
            } catch (e) {
              fileName = rawFileName;
            }
          }
        }

        return dispatch(
          downloadFile(
            response.data,
            fileName,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          )
        );
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response && error.response.status === 422) {
          dispatch(rejectGetCicAlertReport(null));
          toastr.error('Report limit exceeded', 'Your filtered search matches more alerts than can be included in a single report. Please narrow your filters and try again.');
          return;
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetCicAlertReport, true));
        }
      });
    return promise();
  };
}
